export default "__VITE_ASSET__Ccioo0OT__"